import React from "react";
import PropTypes from "prop-types";

import { Icon } from "rhombus-react";

import { noop } from "utils/common";

import "./AdTypePill.css";

export default function AdTypePill(props){
	const {
		name,
		isSelected,
		isValid,
		className = "",
		onClick,
	} = props;

	let statusIcon = null;

	if(isValid !== undefined){
		if(isValid){
			statusIcon = <Icon name="success" className="status-icon success" />;
		} else {
			statusIcon = <Icon name="errorT" className="status-icon warning" />;
		}
	}

	return (
		<span
			className = {`adtype-pill ${className} ${isSelected ? "is-selected" : ""}`}
			onClick = {onClick}
		>
			{statusIcon}
			{name}
		</span>
	);
}

AdTypePill.displayName = "AdTypePill";

AdTypePill.propTypes = {
	name: PropTypes.string,
	isSelected: PropTypes.bool,
	isValid: PropTypes.bool,

	onClick: PropTypes.func,
};

AdTypePill.defaultProps = {
	onClick: noop,
};
